module.exports = __webpack_public_path__ + "img/1523348374.c24a0f2e.jpg";